import { lazy } from 'react';
import { ICONS } from '../navigationIcons';

const AccountsPage = lazy(() => import('src/compass/pages/lrpTeam/AccountsPage'));

export const LrpTeamMenu = [
  {
    menuTitle: 'LRP Team',
    path: 'lrp-team',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Accounts',
        path: 'accounts',
        element: <AccountsPage />,
        permission: 'LRP_ACCOUNTS',
      },
    ],
  },
];
